import React, { useState, useCallback } from 'react';

import useKeyboardShortcuts from '../../hooks/common/useKeyboardShortcuts';
import ShortcutsHelpDialog from './ShortcutsHelpDialog';
import CommandPalette from './CommandPalette';

/**
 * Mounted once at the app root (inside the BrowserRouter so both
 * the hook and CommandPalette have access to navigate).
 */
const KeyboardShortcuts = () => {
    const [helpOpen, setHelpOpen] = useState(false);
    const [paletteOpen, setPaletteOpen] = useState(false);

    const showHelp = useCallback(() => setHelpOpen(true), []);
    const openPalette = useCallback(() => setPaletteOpen(true), []);

    useKeyboardShortcuts({ onShowHelp: showHelp, onOpenPalette: openPalette });

    return (
        <>
            <CommandPalette
                open={paletteOpen}
                onClose={() => setPaletteOpen(false)}
            />
            <ShortcutsHelpDialog
                open={helpOpen}
                onClose={() => setHelpOpen(false)}
            />
        </>
    );
};

export default KeyboardShortcuts;
